import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';

const ColumnChartInadimplenciaVisao = ({ selectedData }) => {
  if (!selectedData) return null;

  const months = selectedData.valor_meses.map((item) => item.nome);
  const pagoData = selectedData.valor_meses.map((item) => item.valor);
  const vencidoData = selectedData.valor_meses.map((item) => item.valor_secundario);
  const percentualInadimplenciaData = selectedData.valor_meses.map((item) => item.valor_terciario);

  const option = {
    title: {
      text: 'Visão Histórica de Inadimplência',
      padding: [16, 5, 5, 23],
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
      formatter: (params) => {
        const tooltipItems = params.map((item) => {
          const value = item.value;
          const formattedValue = item.seriesName === 'Percentual de Inadimplência' ? `${value.toFixed(2)}%` : formatLargeNumber(value);
          return `<div><strong>${item.seriesName}:</strong> ${formattedValue}</div>`;
        }).join('');
        return `<div><strong>${params[0].name}</strong></div>${tooltipItems}`;
      },
    },
    legend: {
      data: [
        {name: 'Valor real', icon: 'circle'},
        {name: 'Percentual de Inadimplência'},
        {name: 'Valor real inadimplente', icon: 'circle'},
      ],
      right: '0',
      padding: [16, 23, 5, 5],
    },
    grid: {
      left: '3%',
      right: '6%',
      bottom: '3%',
      top: '20%',
      containLabel: true,
    },
    yAxis: [
      {
        type: 'value',
        name: 'Valor',
        position: 'left',
      },
      {
        type: 'value',
        name: 'Percentual',
        position: 'right',
        axisLabel: {
          formatter: '{value}%',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
      axisLabel: {
        formatter: (value, index) => {
          return `{percent|${percentualInadimplenciaData[index].toFixed(2)}%}\n{value|${value}}`;
        },
        rich: {
          percent: {
            fontSize: 12,
            color: '#000',
            fontWeight: 'bold',
            padding: [0, 0, 0, 0], 
          },
          value: {
            fontSize: 12,
            color: '#000',
            padding: [5, 0, 0, 0],
          },
        },
      },
    },
    
    series: [
      {
        name: 'Valor real',
        type: 'bar',
        stack: 'total',
        data: pagoData,
        barMaxWidth: 60,
        itemStyle: {
          color: 'rgba(147, 220, 63, 1)',
        },
      },
      {
        name: 'Valor real inadimplente',
        type: 'bar',
        stack: 'total',
        data: vencidoData,
        barMaxWidth: 60,
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
          color: 'rgba(252, 159, 159, 1)',
        },
        label: {
          show: true,
          position: 'top',
          formatter: (params) => `{value|${formatLargeNumber(Number(params.value))}}\n{arrow|▼}`,
          rich: {
            value: {
              backgroundColor: 'rgba(246, 190, 51, 1)',
              color: '#000',
              fontSize: 11,
              padding: [5, 15],
              borderRadius: 5,
            },
            arrow: {
              color: '#F6BE33',
              fontSize: 20,
              align: 'center',
            },
          },
        },
      },
      {
        name: 'Percentual de Inadimplência',
        type: 'line',
        smooth: true,
        yAxisIndex: 1,
        data: percentualInadimplenciaData,
        lineStyle: {
          color: 'black',
          width: 3,
        },
      },
    ],
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartInadimplenciaVisao;
